// extracted by mini-css-extract-plugin
export var container = "Columns-module--container--plM-P";
export var column = "Columns-module--column--jcoKa";